// removed by extract-text-webpack-plugin
module.exports = {"addClientForm":"_2RXt3857Y2yKf6bcb_1PiM","copyTitle":"_3JqSdvicfs64cibcVYk0Zl","copyText":"e0_z90duhMtbPbPx8Lren","formLabel":"RgyS7Cc-nJQZpitUc3154","formControl":"_1s3tOOQQSRD9ECyPlZKF2w","formFieldText":"_2oaroOMDdydFkZCjQPd1cX","addClientButton":"_3n_1mVgAFWO_LpnSAfVByZ","cancelClientButton":"OWAHyz1mGqD7YNK2qggxG"};


//////////////////
// WEBPACK FOOTER
// ./src/components/AdvisorMode/AddClientForm.css
// module id = 1158
// module chunks = 0